import React, { useState } from 'react';
import './ToolsRadar.css';

const TOOLS_DATA = [
  // --- RING 1: CORE SECURITY & INTEL (Inner) ---
  { name: "Burp Suite", domain: "AppSec", ring: 1, angle: 0, desc: "Web Pentesting", url: "https://portswigger.net/burp/documentation" },
  { name: "Nessus", domain: "Vuln Mgmt", ring: 1, angle: 45, desc: "Scanner", url: "https://docs.tenable.com/nessus/" },
  { name: "Sentinel", domain: "Cloud SOC", ring: 1, angle: 135, desc: "Cloud SIEM", url: "https://learn.microsoft.com/en-us/azure/sentinel/" },
  { name: "Defender", domain: "Cloud SOC", ring: 1, angle: 180, desc: "XDR Platform", url: "https://learn.microsoft.com/en-us/microsoft-365/security/defender-endpoint/" },
  { name: "ThreatWorx", domain: "Vuln Mgmt", ring: 1, angle: 225, desc: "Vuln Mgmt", url: "https://www.threatworx.io/" },
  { name: "Cyble", domain: "Intel", ring: 1, angle: 270, desc: "Dark Web Intel", url: "https://cyble.com/" },

  // --- RING 2: SECURITY ARCHITECTURE & OFFENSIVE (Middle) ---
  { name: "CodeQL", domain: "AppSec", ring: 2, angle: 30, desc: "Code Analysis", url: "https://codeql.github.com/docs/" },
  { name: "Threat Model", domain: "AppSec", ring: 2, angle: 90, desc: "Microsoft TMT", url: "https://learn.microsoft.com/en-us/azure/security/develop/threat-modeling-tool" },
  { name: "IRuS Risk", domain: "Risk Mgmt", ring: 2, angle: 150, desc: "Risk Mgmt", url: "https://iris-risk.com/" },
  { name: "Wireshark", domain: "Network", ring: 2, angle: 210, desc: "Packet Analysis", url: "https://www.wireshark.org/docs/" },
  { name: "Metasploit", domain: "Platform", ring: 2, angle: 330, desc: "Exploits", url: "https://docs.metasploit.com/" },

  // --- RING 3: ENGINEERING & DEVSECOPS (Outer) ---
  { name: "Git", domain: "DevSecOps", ring: 3, angle: 45, desc: "Version Control", url: "https://git-scm.com/doc" },
  { name: "VS Code", domain: "DevSecOps", ring: 3, angle: 135, desc: "IDE", url: "https://code.visualstudio.com/docs" },
  { name: "GitHub", domain: "DevSecOps", ring: 3, angle: 225, desc: "Source Control", url: "https://docs.github.com/" },
  { name: "Python", domain: "DevSecOps", ring: 3, angle: 0, desc: "Source Control", url: "https://docs.github.com/" },
  { name: "Kali", domain: "Platform", ring: 3, angle: 270, desc: "Pentest OS", url: "https://www.kali.org/docs/" },
];

const ToolsRadar = () => {
  const [hoveredTool, setHoveredTool] = useState(null);
  const [selectedTool, setSelectedTool] = useState(null);

  const activeIndex = selectedTool !== null ? selectedTool : hoveredTool;

  const handleDotClick = (index, e) => {
    e.stopPropagation(); 
    if (selectedTool === index) {
      setSelectedTool(null); 
    } else {
      setSelectedTool(index);
    }
  };

  const handleBackgroundClick = () => {
    setSelectedTool(null);
  };

  const getPosition = (ring, angle) => {
    // --- CHANGED: Reduced gaps between rings (from 30,60,90 to 25,50,75)
    // 0=Center, 1=25%, 2=50%, 3=75%
    const radii = [0, 25, 50, 75]; 
    const radius = radii[ring];
    const radian = (angle * Math.PI) / 180;
    return {
      left: `${50 + radius * Math.cos(radian)}%`,
      top: `${50 + radius * Math.sin(radian)}%`,
    };
  };

  return (
    <section 
      id="tools" 
      className="tools-radar-section" 
      aria-labelledby="tools-heading"
      onClick={handleBackgroundClick}
    >
      <div className="seo-hidden-block">
        <h2 id="tools-heading">Cybersecurity Tools & Operations Stack</h2>
      </div>

      <div className="radar-instruction">
        <span className="blink-arrow">&gt;&gt;</span> Click nodes to access documentation_
      </div>

      <div className="radar-container">
        
        <div className="radar-grid">
          <div className="radar-sweep"></div>
          
          <div className="radar-ring ring-1"></div>
          <div className="radar-ring ring-2"></div>
          <div className="radar-ring ring-3"></div>
        </div>

        <div className="radar-center">
          <span>Tools</span>
        </div>

        {TOOLS_DATA.map((tool, index) => {
          const style = getPosition(tool.ring, tool.angle);
          const isActive = activeIndex === index;

          return (
            <div
              key={index}
              className={`tool-dot ${isActive ? 'active' : ''}`}
              style={style}
              onMouseEnter={() => setHoveredTool(index)}
              onMouseLeave={() => setHoveredTool(null)}
              onClick={(e) => handleDotClick(index, e)}
              role="button"
              tabIndex={0}
              aria-label={`View details for ${tool.name}`}
            >
              <span className="tool-dot-label">{tool.name}</span>

              <div className="tool-pulse"></div>
              
              <div className={`tool-tooltip ${isActive ? 'visible' : ''}`}>
                <div className="tooltip-content">
                  <a 
                    href={tool.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="tooltip-name-link"
                    onClick={(e) => e.stopPropagation()} 
                  >
                    {tool.name} ↗
                  </a>
                  <div className="tooltip-desc">{tool.desc}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ToolsRadar;